import { css } from 'styled-components';

/* Remember to import Schibsted font:
* https://fonts.google.com/specimen/Schibsted+Grotesk?query=Schibsted+G
* Weights: 400 and 700
* Do we need italic variants?
 */

export const typography = css`
    --font-family: 'Schibsted Grotesk', system-ui, blinkmacsystemfont, -apple-system,
    'Segoe UI', roboto, helvetica, arial, sans-serif;

    --font-weight-light: 400;
    --font-weight-bold: 700;

    --font-size-display-lg: 3.65625rem; // 58.5px
    --font-size-display-md: 3.25rem;    // 52px
    --font-size-display-sm: 2.8875rem;  // 46.2px

    --font-size-headline-lg: 2.5625rem; // 41px
    --font-size-headline-md: 2.28125rem; // 36.5px
    --font-size-headline-sm: 2.025rem;  // 32.4px

    --font-size-title-lg: 1.8rem;       // 28.8px
    --font-size-title-md: 1.6rem;       // 25.6px
    --font-size-title-sm: 1.425rem;     // 22.8px

    --font-size-body-lg: 1.26875rem;    // 20.3px
    --font-size-body-md: 1.125rem;      // 18px
    --font-size-body-sm: 1rem;          // 16px

    --font-size-label-xl: 0.9375rem;    // 15px
    --font-size-label-lg: 0.8875rem;    // 14.2px
    --font-size-label-md: 0.7875rem;    // 12.6px
    --font-size-label-sm: 0.7rem;       // 11.2px

    --line-height-display: 110%;
    --line-height-headline: 130%;
    --line-height-title: 130%;
    --line-height-body: 150%;
    --line-height-label: 150%;
`;
